import { CommandParser } from '@redis/client/dist/lib/client/parser';
import { RedisArgument, ArrayReply, NumberReply, NullReply, Command, } from '@redis/client/dist/lib/RESP/types';

export default {
  parseCommand(parser: CommandParser, key: RedisArgument, path: RedisArgument) {
    parser.push('JSON.TOGGLE');
    parser.pushKey(key);
    parser.push(path);
  },
  transformReply: undefined as unknown as () => NumberReply | NullReply | ArrayReply<NumberReply | NullReply>
} as const satisfies Command;
